import { ReactElement } from 'react';

import { commonTranslationKeys } from '@dreryk/react-common';
import { LoaderSpinner, Message, MessageType } from '@dreryk/react-components';
import { useDraftCqrsFind } from '@dreryk/react-draft';

import { dischargeSummaryDraftSchema } from '../dischargeSummary.draft';
import { getDischargeSummaryDraftToken } from '../dischargeSummary.utils';
import { DischargeSummaryFormBean } from '../DischargeSummaryForm/DischargeSummaryForm.types';

type DischargeSummaryPanelLoaderChildrenProps = {
   dischargeSummaryDraft: DischargeSummaryFormBean | null;
};
type DischargeSummaryPanelLoaderProps = {
   readonly children: (props: DischargeSummaryPanelLoaderChildrenProps) => JSX.Element;
   readonly visitId: number;
};

export const DischargeSummaryPanelLoader = (props: DischargeSummaryPanelLoaderProps): ReactElement => {
   const {
      data: dischargeSummaryDraft,
      loading: dischargeSummaryDraftLoading,
      error: dischargeSummaryDraftError,
   } = useDraftCqrsFind(
      {
         token: getDischargeSummaryDraftToken(props.visitId),
      },
      dischargeSummaryDraftSchema
   );

   if (dischargeSummaryDraftLoading) {
      return <LoaderSpinner />;
   }

   if (dischargeSummaryDraftError) {
      return (
         <Message
            testId={'error'}
            type={MessageType.NEGATIVE}
            label={commonTranslationKeys.unexpectedErrorHasOccurred}
            displayIndicator
         />
      );
   }

   return props.children({ dischargeSummaryDraft: dischargeSummaryDraft?.contents ?? null });
};
